<template>
    <div class="w-full table-draggable table-flex">
        <div class="table-header">
            <div class="table-header-row">
                <div :key=index :style="{ width: columnsWidth[index] }"
                     class="column table-cel"
                     v-for="(column, index) in columns">
                    <div class="table-cell-inner">
                        {{ column.title || '#' }}
                        <span class="ivu-table-sort" v-if="column.sortable">
                                    <i :class="order.key === column.key && order.dir === 'asc'  ? 'on' : ''"
                                       @click="onSort(column.key, 'asc')"
                                       class="ivu-icon ivu-icon-md-arrow-dropup"></i>
                                    <i :class="order.key === column.key && order.dir === 'desc'  ? 'on' : ''"
                                       @click="onSort(column.key, 'desc')"
                                       class="ivu-icon ivu-icon-md-arrow-dropdown"></i>
                                </span>
                        <DropdownList :class="column._filterChecked ? 'on' : ''" :id="index"
                                      :list="filterList(column.filters)"
                                      :onSelect="addFilter" :selected="column._filterChecked"
                                      icon="ios-funnel" v-if="column.filters"/>
                    </div>
                </div>
            </div>
        </div>
        <div ref="table-scroll" :style="offsetTop ? {overflowY: 'auto', height: `calc(100vh - ${offsetTop}px)`} : ''">
            <Container :get-child-payload="getChildPayload" :group-name="groupName" :lock-axis="lockAxis" @drop="onDrop"
                       class="table-body" drag-handle-selector=".drag-selector" non-drag-area-selector=".block-drag">
                <Draggable
                        :class="['table-row', {'drag-selector': dragActive && !dragByColumn, 'block-drag': ticket.block_drag}]"
                        :key="p_idx"
                        v-for="(ticket, p_idx) in filtered_data">
                    <div :class="['column table-cel', {'drag-selector': dragActive && column.key===dragByColumn}, {'primeiro-item': p_idx == 0}]"
                        :key="listKey ? `${ticket[listKey]}_${index}` : index"
                        :style="[{ width: columnsWidth[index] }]"
                        v-for="(column, index) in columns">
                        <div class="table-cell-inner">
                            <CustomRender
                                    :column="column"
                                    :index="index"
                                    :render="column.render"
                                    :row="ticket"
                                    v-if="column.render"></CustomRender>
                            {{ !column.render ? ticket[column.key] : '' }}
                        </div>
                    </div>
                </Draggable>
            </Container>
        </div>
    </div>
</template>

<script>
    const _ = require("lodash");
    import elementResizeDetectorMaker from 'element-resize-detector';

    export default {
        name: 'table-draggable',
        components: {
            Container: () =>
                import("vue-smooth-dnd").then(({Container}) => Container),
            Draggable: () =>
                import("vue-smooth-dnd").then(({Draggable}) => Draggable)
        },
        props: {
            csv: Boolean,
            dataItems: Array,
            columns: Array,
            drop: Function,
            getChildPayload: Function,
            tableWidth: Number,
            lockAxis: String,
            dragByColumn: String,
            defaultOrder: Object,
            dragDisabled: Boolean,
            noSort: Boolean,
            groupName: [Number, String],
            dataUpdated: Function,
            offsetTop: Number,
            listKey: {
                type: String,
                default: null
            },
            dragWithFilter: {
                type: Boolean,
                default: false
            },
            /**
             * Ao alterar este callback, tem que tratar localmente o posicionamento que será trocado
             * Pois pode alterar a posição dos tickets de forma errada
             * Para ativar o highlight use o parametro defaultOrder em conjunto
             */
            onSort: {
                required: false,
                type: Function,
                default: function (key, dir) {
                    this.setOrder(key, dir)
                }
            }
        },
        data() {
            return {
                filtered_data: [],
                filter_active: false,
                columnsWidth: {},
                order: {
                    key: 'posicao',
                    dir: 'asc'
                }
            };
        },
        computed: {
            /**
             * Ativa a ordenação apenas se estiver ordenado pela chave posição
             */
            dragActive() {
                if (this.dragDisabled) return false;
                if (!this.defaultOrder) return true;
                const key = this.defaultOrder.key || 'posicao';
                const dir = this.defaultOrder.dir || 'asc';
                return this.order.key === key && this.order.dir === dir && (this.dragWithFilter ? true : !this.filter_active);
            },
        },
        methods: {
            onDrop(dragResult) {
                this.$emit('drop', dragResult)
            },
            filterList(list) {
                let clonelist = [...list];
                clonelist.unshift({
                    value: 0,
                    label: "Todos"
                });
                return clonelist;
            },
            updateData(sort = true) {
                let data = this.setFilters(this.dataItems, this.columns);
                if (sort && this.order.key && this.order.dir) {
                    data = _.orderBy(data, [this.order.key], [this.order.dir]);
                }
                this.filtered_data = data;
                this.$emit('dataUpdated', data);
            },
            setFilters(data, columns) {
                columns.forEach((col) => {
                    if (col._filterChecked) {
                        data = this.filterData(data, col);
                    }
                });
                return data;
            },
            filterData(data, column) {
                return data.filter((row) => {
                    if (!column._filterChecked) return true;
                    return column.filterMethod(column._filterChecked, row);
                });
            },
            resetOrder() {
                this.order = {
                    key: this.defaultOrder ? this.defaultOrder.key : 'posicao',
                    dir: this.defaultOrder ? this.defaultOrder.dir : 'asc'
                };
            },
            setOrder(key, dir) {
                if (this.order.key === key && this.order.dir === dir) {
                    this.resetOrder();
                    this.updateData(false);
                } else {
                    this.order.key = key;
                    this.order.dir = dir;
                    this.updateData(!this.noSort);
                }
            },
            addFilter(idx, value) {
                this.filter_active = !!value;
                this.columns[idx]._filterChecked = value;
                this.updateData(!this.noSort);
            },

            exportData () {
                const dataCsv = [];
                this.filtered_data.forEach(ticket => {
                    const newTicket = {};
                    this.columns.forEach((coluna, index) => {
                        if (ticket[coluna.key]) {
                            newTicket[coluna.title] = ticket[coluna.key].toString().replace(/,/g, " ").replace(/\n+/, " ");
                        } else {
                            newTicket[`Coluna ${index}`] = " ";
                        }
                    });
                    dataCsv.push(newTicket);
                });

                this.csvExport(dataCsv);
            },

            csvExport (arrData) {
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += [
                    Object.keys(arrData[0]).join(";"),
                    ...arrData.map(item => Object.values(item).join(";"))
                ].join("\n").replace(/(^\[)|(\]$)|(\#)/gm, "");

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "export.csv");
                link.click();
            },
            handleResize: _.throttle(function () {
                let tableWidth = this.$el.offsetWidth - 1;
                let hasWidthColumns = [];
                let noWidthColumns = [];
                this.columns.forEach((col, index) => {
                    col._index = index;
                    if (col.width) {
                        hasWidthColumns.push(col);
                    } else {
                        noWidthColumns.push(col);
                    }
                    col._width = null;
                });
                let unUsableWidth = hasWidthColumns.map(cell => cell.width).reduce((a, b) => a + b, 0);
                let usableWidth = tableWidth - unUsableWidth - 1;
                let usableLength = noWidthColumns.length;
                let columnWidth = 0;
                if (usableWidth > 0 && usableLength > 0) {
                    columnWidth = parseInt(usableWidth / usableLength);
                }
                let columnsWidth = {};
                noWidthColumns.forEach(col => {
                    columnsWidth[col._index] = `${columnWidth}px`;
                });
                hasWidthColumns.forEach(col => {
                    columnsWidth[col._index] = Number.isInteger(col.width) ? `${col.width}px` : col.width;
                });
                this.columnsWidth = columnsWidth;

            }, 100),
            handleScroll: _.throttle(function (e) {
                const el = e.target.documentElement || e.target;
                let windowRelativeBottom = el.scrollHeight - el.offsetHeight;
                if (el.scrollTop > windowRelativeBottom - 50) {
                    this.$emit('scrollEnd');
                }
            }, 1000),
        },
        watch: {
            dataItems: function () {
                this.updateData(!this.noSort);
                this.resetOrder();
            },
            csv(){
                if(this.csv){
                    this.exportData()
                }
            }
        },
        mounted() {
            this.updateData(!this.noSort);
            this.handleResize();
            this.observer = elementResizeDetectorMaker();
            this.observer.listenTo(this.$el, this.handleResize);
            this.tableScroll = this.$refs["table-scroll"];
            this.$nextTick(() => {
                this.tableScroll.addEventListener('scroll', this.handleScroll);
            });
        },
        beforeDestroy() {
            this.observer.removeListener(this.$el, this.handleResize);
            this.tableScroll.removeEventListener('scroll', this.handleScroll);
        },
    }
</script>

<style lang="scss" scoped>
    .primeiro-item{
        padding-bottom: 20px;padding-top: 20px;
    }
</style>